<ng-container *ngIf="currentBac$ | async as currentBac">
  <h1>{{ currentBac.translated$ | async }}</h1>
  <div class="search-filter">
    <rk-search-bar #searchBar (inputted)="onChangeSearch($event)"></rk-search-bar>
    <rk-icon-button
      faIcon="fa-list"
      color="brand"
      [bordered]="true"
      [size]="28"
      [style]="{ width: '45px', height: '45px' }"
      (click)="openBacPlaylistModal()"
    ></rk-icon-button>
  </div>
</ng-container>

<div
  class="list flex"
  [class.listening]="!!(currentTrack$ | async)"
  [class.empty]="!(tracks$ | async).length"
>
  <ng-container *ngIf="!(isLoading$ | async); else loading_list">
    <ng-container *ngIf="(tracks$ | async).length; else noTracks">
      <cdk-virtual-scroll-viewport
        itemSize="60"
        class="flex-1"
        minBufferPx="800"
        maxBufferPx="1000"
      >
        <rk-track-mobile-line
          class="block mb-4.5"
          *cdkVirtualFor="let track of tracks$ | async; templateCacheSize: 60"
          [track]="track"
        ></rk-track-mobile-line>
      </cdk-virtual-scroll-viewport>
    </ng-container>
  </ng-container>
</div>

<ng-template #loading_list>
  <div class="mt-32 w-full">
    <rk-loader [isLoading]="true" [size]="60" [center]="true"></rk-loader>
  </div>
</ng-template>

<ng-template #noTracks>
  <div class="box-empty mx-4">
    <img src="/assets/box-empty.svg" />
    <div translate>MEDIA.TABLE.BOX_EMPTY</div>
  </div>
</ng-template>

<rk-library-upload-track [box]="currentBac$ | async"></rk-library-upload-track>
